export var ChatType;
(function (ChatType) {
    ChatType["ChatTypeHuman"] = "Human";
    ChatType["ChatTypeAgent"] = "Agent";
})(ChatType || (ChatType = {}));
